module.exports = __webpack_public_path__ + "img/默认图片.d433f689.png";